module.exports = __webpack_public_path__ + "img/logo-essae.753fd00d.png";